// 英文工作台
export default {
  'workplace.welcome': 'Hello',
  'workplace.login-time': 'Last login time',
  'workplace.login-address': 'Last login address',
  'workplace.user': 'user',
  'workplace.actor': 'actor',
  'workplace.article': 'article'
}